module.exports = __webpack_public_path__ + "static/media/neo-sans-bold.6d462272.woff2";